
import React, { type CSSProperties } from "react";

import classNames from "classnames";
import PosterWithWatchlist from "src/components/posterrow/PosterWithWatchlist";
import type { Movie, StreamingContent } from 'src/lib/movieinfo/movieinfotypes';
import type { IFilmomtale } from 'src/lib/types/Filmomtale';
import cssPosterStyles from "./CSSPoster.module.css";
import styles from "./PosterRow.module.css";
import type OptionalPosterInfoType from "src/components/posterrow/OptionalPosterDisplayType";

//#region [Props]
type PosterRowProps = {
    posterList?: null | undefined | (IFilmomtale | Movie | StreamingContent)[];
    max?: number;
    renderPlaceholders?: boolean;
    className?: string;
    optionalDisplay?: OptionalPosterInfoType;
    longTitle?: boolean;
    hideKinoklubbBanner?: boolean;
    hideWatchlistMobile?: boolean;
	hideWatchlistDesktop?: boolean;
    headerLevel?: 2 | 3 | 4 | 5 | 6;
    promoOverlay?: React.ReactNode;
    posterOverlays?: React.ReactNode[];
    posterClassName?: string;
	watchlistButtonClassName?: string;
};
//#endregion


//#region [Component]
export default function PosterRow({
    posterList,
    max = 0,
    renderPlaceholders = false,
    className,
    optionalDisplay,
    longTitle = false,
    hideKinoklubbBanner = false,
    headerLevel = 2,
    hideWatchlistMobile = false,
	hideWatchlistDesktop = false,
    promoOverlay,
    posterOverlays,
	watchlistButtonClassName
}: PosterRowProps) {
    if ((posterList?.length ?? 0) === 0) {
        return null;
    }

    const list = posterList!.slice(0, max > 0 ? max : posterList!.length!);

    return <div className={classNames("posterrow", className, styles.SRowContainer)}>
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any*/}
        {list?.map((film, index) => <PosterWithWatchlist key={(film as any)?._id ?? (film as any)?.mainVersionId ?? (film as any)?.id}
            wlcHideOnMobile={hideWatchlistMobile}
			wlcHideOnDesktop={hideWatchlistDesktop}
            film={film}
            sizes='(orientation: landscape) 203px, 25vw'
            wlcClassName={classNames("posterrow_poster", styles.ItemContainer)}
            className={styles.SPoster}
            optionalDisplay={optionalDisplay}
            longTitle={longTitle}
            hideKinoklubbBanner={hideKinoklubbBanner}
            headerLevel={headerLevel}
            posterOverlay={posterOverlays?.[index]}
			wlcButtonClassName={watchlistButtonClassName}
        >{promoOverlay}</PosterWithWatchlist>)}
        {renderPlaceholders && (list?.length ?? 0) < max && max > 0 && times(max - (list?.length ?? 0), (idx) => <Placeholder key={idx} className={classNames(styles.ItemContainer, cssPosterStyles.CSSPoster)} />)}
    </div>;
}
//#endregion

//#region [Component]
type PlaceholderProps = {
    className?: string;
}

function Placeholder({ className }: PlaceholderProps) {
    return <div className={className}></div>
}
//#endregion


function times(num: number, renderFunc: (index: number) => React.ReactNode): React.ReactNode | null {
    if (num > 0) {
        return Array.from(Array(num)).map((itm, index) => renderFunc(index));
    }
    return null;
}